<template>
  <div class="account-dorm">
    <MultiStepForm
      :step-titles="stepTitles"
      :step="step"
      :max-step="5"
      :loading="loading"
      @update:step="step = $event"
      @submit="save"
      class="user__list-offer"
    >
      <template #step-1>
        <div class="col-xl-12">
          <keep-alive>
            <v-select
              :options="dorms"
              placeholder="Yurt Seçiniz"
              v-model="dorm_id"
              :selected-value="dorm_id"
              style="font-weight: bold"
              @onselect="selectDorm"
            />
          </keep-alive>
        </div>
      </template>
      <template #step-2>
        <div class="col-xl-12">
          <v-input placeholder="Oda Adı" v-model="title" />
          <v-input
            placeholder="Oda Kapasitesi (Kişi)"
            type="number"
            v-model="capacity"
          />
          <v-input placeholder="Yatak Sayısı" type="number" v-model="number" />
          <v-input
            placeholder="Oda Büyüklüğü (m2)"
            type="number"
            v-model="size"
          />
          <Checkbox :value="is_active" @update="is_active = !is_active"
            >Oda Aktif (Herkes görebilir)</Checkbox
          >
        </div>
      </template>
      <template #step-3>
        <div class="col-xl-12">
          <
            :gallery="images"
            @update="images = $event"
            @delete="deleteImage"
          ></ >
        </div>
      </template>
      <template #step-4>
        <div class="col-xl-12">
          <DormRoomFeatures
            :build-features="buildFeatures"
            :room-features="roomFeatures"
            :services="services"
            @update="updateRoomFeature"
          ></DormRoomFeatures>
        </div>
      </template>
      <template #step-5>
        <div class="col-xl-12">
          <v-input placeholder="Günlük Fiyat (TL)" v-model="daily_price" />
          <v-input placeholder="Aylık Fiyat (TL)" v-model="monthly_price" />
          <Checkbox
            :value="is_sale_active"
            @update="is_sale_active = !is_sale_active"
            >Satış Aktif</Checkbox
          >
        </div>
      </template>
    </MultiStepForm>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox/Checkbox.vue'
import MultiStepForm from '@/components/Form/MultiStepForm.vue'
import RoomGallery from '@/components/Room/RoomGallery.vue'
import {
  buildFeatures,
  roomFeatures,
  services
} from '@/static/dorm-properties.js'
import { toFormData } from '@/utils/form-data'
import axios from 'axios'
import DormRoomFeatures from './DormRoomFeatures.vue'

export default {
  components: {
    MultiStepForm,
    Checkbox,
    DormRoomFeatures,
    RoomGallery
  },
  data() {
    return {
      step: 0,
      loading: false,
      stepTitles: [
        {
          title: 'Yurt Seçimi',
          subtitle: 'Yurt seçimi yaparak oda eklemeye başlayabilirsiniz.'
        },
        {
          title: 'Oda Bilgileri',
          subtitle: 'Oda bilgilerini girerek oda eklemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Görselleri',
          subtitle:
            'Oda görsellerini yükleyerek oda eklemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Özellikleri',
          subtitle:
            'Oda özelliklerini girerek oda eklemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Fiyatları',
          subtitle:
            'Oda fiyat bilgilerini girerek oda eklemeyi tamamlayabilirsiniz.'
        }
      ],
      dorms: [],
      buildFeatures: [],
      roomFeatures: [],
      images: [],
      services: [],
      dorm_id: '0',
      title: '',
      number: 0,
      capacity: '0',
      size: '0',
      daily_price: 0,
      monthly_price: 0,
      is_sale_active: true,
      is_active: false
    }
  },
  methods: {
    uploadImage(image) {
      this.images.push(image)
    },
    deleteImage(image) {
      this.images = this.images.filter(i => i.id !== image.id)
    },
    updateRoomFeature({ key, id }) {
      this[key].forEach(b => {
        if (b.id === id) b.value = !b.value
      })
    },
    selectDorm(opt) {
      this.dorm_id = String(opt.id)
    },
    getFeatureList() {
      this.buildFeatures = buildFeatures.map(b => ({ ...b, value: false }))
      this.roomFeatures = roomFeatures.map(b => ({ ...b, value: false }))
      this.services = services.map(b => ({ ...b, value: false }))
    },
    async getDorms() {
      const res = await axios.get('/dorm/dorms').catch(() => ({ data: [] }))
      this.dorms = res.data.map(r => ({ ...r, id: String(r.id) }))
    },
    async save() {
      this.loading = true
      let data = {
        dorm_id: +this.dorm_id,
        title: this.title,
        capacity: +this.capacity,
        size: +this.size,
        number: this.number,
        daily_price: this.daily_price,
        monthly_price: this.monthly_price,
        is_sale_active: +this.is_sale_active,
        is_active: +this.is_active,
        props: [],
        images: []
      }
      this.buildFeatures
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      this.images.forEach(image => {
        data.images.push(image.file)
      })
      this.roomFeatures
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      this.services
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      const res = await axios
        .post('/dorm/rooms', toFormData(data))
        .catch(() => ({ data: {}, status: 400 }))
      this.loading = false
      if (![200, 201].includes(res.status)) {
        this.$toast.center('Bir hata oluştu.')
      } else {
        this.$toast.center('Oda başarıyla eklendi.')
        this.$router.push('/yurt-yonetimi/yurtlar/odalar')
      }
    }
  },
  mounted() {
    this.getDorms()
    this.getFeatureList()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/components/dorm-room';
</style>
